import React from 'react';
import PropTypes from 'prop-types';
import Alert from 'react-bootstrap/Alert';
import InfoOutlined from '@material-ui/icons/InfoOutlined';
import FooterPanel from './FooterPanel';
import HeaderPanel from './HeaderPanel';
const Summary = ({ changeEv, title, variant, alertInfo, alertInfoHtml, hideContent }) => {
    return (
        <div className="sign__summary">
            <HeaderPanel>{title}</HeaderPanel>
            <Alert variant={variant}>
                <InfoOutlined />
                {alertInfo && <p dangerouslySetInnerHTML={{ __html: alertInfo }} />}
                {!alertInfo && alertInfoHtml}
            </Alert>
            {!hideContent && <div className="sign__summary--content">
                <div className="sign__summary--header">Nie dostałeś e-maila?</div>
                <ol className="sign__summary--list">
                    <li>Sprawdź folder ze spamem.</li>
                    <li>Upewnij się ze podałeś prawidłowy adres.</li>
                    <li>Zaczekaj chwilę i sprawdź ponownie.</li>
                </ol>
            </div>}

            <FooterPanel changeEv={() => changeEv('login')}>Powrót do logowania</FooterPanel>
        </div>
    );
};

Summary.propTypes = {
    changeEv: PropTypes.func.isRequired,
    title: PropTypes.string,
    variant: PropTypes.string,
    alertInfo: PropTypes.string,
    hideContent: PropTypes.bool,
    alertInfoHtml: PropTypes.any,
};

export default Summary;
